const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const SUPPORTED_AUTH_MODES = new Set(['whatsapp', 'password', 'local']);

export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://rebase.api.seasideapis.com';

const getHostname = (url) => {
  try {
    return new URL(url, window.location.origin).hostname;
  } catch (_error) {
    return '';
  }
};

export const isLocalFrontend = LOCAL_HOSTNAMES.has(window.location.hostname);
export const isLocalApi = LOCAL_HOSTNAMES.has(getHostname(apiBaseUrl));

const configuredAuthMode = process.env.REACT_APP_AUTH_MODE?.trim().toLowerCase();
const defaultAuthMode = isLocalFrontend && isLocalApi ? 'local' : 'whatsapp';

export const authMode = SUPPORTED_AUTH_MODES.has(configuredAuthMode)
  ? configuredAuthMode
  : defaultAuthMode;

export const canUseLocalAuth = authMode === 'local' && isLocalFrontend && isLocalApi;
export const canUsePasswordAuth = authMode === 'password' && isLocalFrontend;

export const authConfigurationError = (() => {
  if (configuredAuthMode && !SUPPORTED_AUTH_MODES.has(configuredAuthMode)) {
    return `Unsupported authentication mode: ${configuredAuthMode}`;
  }

  if (authMode === 'local' && !canUseLocalAuth) {
    return 'Local authentication requires both the frontend and API to run locally.';
  }

  if (authMode === 'password' && !isLocalFrontend) {
    return 'Password test authentication is available only from a local frontend.';
  }

  return null;
})();
